<template>
  <authorization permissionKey="configuration_contact_len" can="read">
    <v-container fluid>
      <v-row>
        <v-col class="text-h3 gray--text">
          Lentes de contato
        </v-col>
      </v-row>

      <v-row>
        <v-col>
          <v-tabs background-color="transparent" color="secondary">
            <v-tab to="/configuracoes/lentes-contato/materiais">Materiais</v-tab>
            <v-tab to="/configuracoes/lentes-contato/desenhos">Desenhos</v-tab>
            <v-tab to="/configuracoes/lentes-contato/fabricantes">Fabricantes</v-tab>
            <v-tab to="/configuracoes/lentes-contato/caixas">Caixas</v-tab>
          </v-tabs>
        </v-col>
      </v-row>

      <router-view />
    </v-container>
  </authorization>
</template>

<script>
  export default {
    name: "ContactLenConfig",
  };
</script>

<style lang="scss" scoped></style>
